import { TRouteOverrides } from 'helpers/applyRouteOverrides'

import {
  FEMI_RETENTION_FLOW_V2_ROUTES,
  RETENTION_FLOW_V2_ROUTES,
} from 'modules/retentionFlowV2/routes'

import { AppName } from 'root-constants'

export const APP_ROUTE_OVERRIDES: Partial<Record<AppName, TRouteOverrides>> = {
  [AppName.FEMI]: FEMI_RETENTION_FLOW_V2_ROUTES,
  [AppName.LUVLY]: RETENTION_FLOW_V2_ROUTES,
}
